module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-3b062a0eb9ced70b2ed5cb070e993022.png";